module.exports = __webpack_public_path__ + "static/media/services_logo_tacugama.914df685.png";